<template>
    <div>

        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
            v-if="paciente"
        >

            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}
                                <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                    ({{ paciente.nomeSocial }})
                                </strong>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>

                            <p>
                                <strong>Prontuário:</strong>
                                {{ paciente.prontuario }}
                            </p>

                            <p>
                                <strong>Telefones: </strong>
                                <template v-if="paciente.telefones">
                                    {{ handlePhone(paciente.telefones) }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Sexo: </strong>
                                <template v-if="paciente.sexo">
                                    {{ paciente.sexo.descricao }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CPF: </strong>
                                <template v-if="paciente.cpf">
                                    {{ paciente.cpf | formatCpf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Data de nascimento: </strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento | formatDate }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="paciente.nomeMae">
                                    {{ paciente.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CNS: </strong>
                                <template v-if="paciente.cns">

                                    {{ paciente.cns | formatCns }}
                                </template>

                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Idade: </strong>
                                <template v-if="paciente.idade">
                                    {{ paciente.idade.anos }} anos,
                                    {{ paciente.idade.meses }} meses e
                                    {{ paciente.idade.dias }} dias
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-table
            :fields="fields"
            :items="items"
        >

            <template v-slot:cell(data)="row">
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(dataExportacao)="{ item }">
                {{ item.dataExportacao }} - {{ item.profissionalExportacao }}
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    @click.stop="search(item)"
                    color="primary"
                    title="Visualizar"
                    small
                >
                    <rkm-icon icon="search" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

// Mixins.
import { repository, error, printExameLaboratorial } from '@/mixins'

// Filters.
import format from '@/filters/formats'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    created() {

        this.repositories = {
            atendimentoIndividual: this.getConectaSusRepository('atencaoBasica.atendimentoIndividual')
        }

        this.load()
    },
    data: () => ({
        fields: [
            {
                key: 'data',
                label: 'Data',
                sortable: true
            },
            {
                key: 'turno',
                label: 'Turno',
                sortable: true
            },
            {
                key: 'localAtendimento',
                label: 'Local de atendimento',
                sortable: true
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true
            },
            {
                key: 'dataExportacao',
                label: 'Exportação',
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            paciente: null,
        },
        items: [],
        paciente: null,
        enums: {
            preferenciaNome
        },
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id) {
                this.setLoading()

                this.repositories.atendimentoIndividual.getAtendimentos({ id : this.id })
                    .then(response => {

                        this.additionals = response.data.additionals
                        this.items = Object.assign(response.data.atendimentos)
                        this.paciente = Object.assign(response.data.cidadao)

                        this.$emit('paciente', response.data.cidadao)

                        this.loaded = true

                        this.$emit('loaded', {additionals: this.additionals, cidadao: this.paciente})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        search(item) {

           this.$router.push({ name: 'atencao-basica-atendimento-individual-edit', params: { id: item.id, pacienteId: this.id }})
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.atendimentoIndividual.destroy(id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === id), 1))

            this.showDeleteConfirmation(`Quando um atendimento individual é excluído, se houver um atendimento de
                procedimento vinculado a ele, o atendimento de procedimento também será excluído. Deseja realmente
                excluir o atendimento?`, destroy, this.handleError)
        },
    },
    mixins: [ repository, error, printExameLaboratorial ],
    props: {
        id: { type: Number, default: null }
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
</style>